import { render, staticRenderFns } from "./PageNation.vue?vue&type=template&id=16a5ce7e&"
import script from "./PageNation.vue?vue&type=script&lang=ts&"
export * from "./PageNation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports